<template>
    <b-container fluid class="mt-4">
        <b-row class="row mt-3">
            <b-col cols="12" md="4" class="mb-4 mb-lg-0">
                <people-tired></people-tired>
            </b-col>
            <b-col cols="12" md="4" class="mb-4 mb-lg-0">
                <people-feel-unwell></people-feel-unwell>
            </b-col>
            <b-col cols="12" md="4" class="mb-4 mb-lg-0">
                <general-symptoms></general-symptoms>
            </b-col>
        </b-row>
        <b-row class="row mt-3">
            <b-col cols="12" md="4" class="mb-4 mb-lg-0">
                <people-feeling-unwell></people-feeling-unwell>
            </b-col>
            <b-col cols="12" md="4" class="mb-4 mb-lg-0">
                <people-co-morbitidites></people-co-morbitidites>
            </b-col>
            <b-col cols="12" md="4" class="mb-4 mb-lg-0">
                <cough></cough>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import PeopleTired from '@/components/Stats/PeopleTired'
    import PeopleFeelUnwell from '@/components/Stats/PeopleFeelUnwell'
    import GeneralSymptoms from '@/components/Stats/GeneralSymptoms'
   import PeopleFeelingUnwell from '@/components/Stats/PeopleFeelingUnwell'
    import PeopleCoMorbitidites from '@/components/Stats/PeopleCoMorbitidites'
    import Cough from '@/components/Stats/Cough'
/*     import Headaches from '@/components/Stats/Headaches'
    import BodyAches from '@/components/Stats/BodyAches'
    import SymptomPeople from '@/components/Stats/SymptomsPeople' */

    export default {
        components: {
            PeopleTired,
            PeopleFeelUnwell,
            GeneralSymptoms,
            PeopleFeelingUnwell,
            PeopleCoMorbitidites,
            Cough,
/*             Headaches,
            BodyAches,
            SymptomPeople */
        }
    }
</script>